import localFont from "next/font/local";
import { Inter } from "next/font/google";

export const inter = Inter({
  weight: ["300", "400", "500", "600", "700", "800"],
  subsets: ["latin"],
  display: "swap",
  fallback: [
    "-apple-system",
    "BlinkMacSystemFont",
    "Helvetica",
    "Arial",
    "sans-serif",
  ],
});

export const domaineDisplay = localFont({
  src: [
    {
      path: "../../assets/fonts/Domaine Display.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "../../assets/fonts/Domaine Display Medium Regular.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "../../assets/fonts/Domaine Display Semibold Regular.woff2",
      weight: "600",
      style: "normal",
    },
  ],
  display: "swap",
  fallback: ["Georgia", "Times New Roman", "serif"],
});

const serif = domaineDisplay.style.fontFamily;

const typography = {
  fontFamily: `-apple-system, BlinkMacSystemFont, ${inter.style.fontFamily}`,
  h1: {
    fontFamily: serif,
    fontWeight: 600,
    fontSize: "2.5rem", // 40px
    lineHeight: 1.1,
    letterSpacing: "0em",
  },
  h2: {
    fontFamily: serif,
    fontWeight: 600,
    fontSize: "2rem", // 32px
    lineHeight: 1.15,
    letterSpacing: "0em",
  },
  h3: {
    fontFamily: serif,
    fontWeight: 500,
    fontSize: "1.75rem", // 28px
    lineHeight: 1.2,
    letterSpacing: "0em",
  },
  h4: {
    fontWeight: 500,
    fontSize: "1.3125rem", // 21px
    lineHeight: 1.25,
    letterSpacing: "0",
  },
  h5: {
    fontWeight: 600,
    fontSize: "1.125rem", // 18px
    lineHeight: 1.35,
    letterSpacing: "0",
  },
  h6: {
    fontWeight: 500,
    fontSize: "1rem", // 16px
    lineHeight: 1.4,
    letterSpacing: "0",
  },
  h1b: {
    fontFamily: serif,
    fontWeight: 600,
    fontSize: "2.5rem", // 40px
    lineHeight: 1.1,
    letterSpacing: "0em",
  },
  h2b: {
    fontFamily: serif,
    fontWeight: 600,
    fontSize: "2rem", // 32px
    lineHeight: 1.15,
    letterSpacing: "0em",
  },
  h3b: {
    fontFamily: serif,
    fontWeight: 600,
    fontSize: "1.75rem", // 28px
    lineHeight: 1.2,
    letterSpacing: "0em",
  },
  h4b: {
    fontWeight: 700,
    fontSize: "1.3125rem", // 21px
    lineHeight: 1.25,
    letterSpacing: "0",
  },
  body1: {
    fontSize: "1.0625rem", // 17px
    fontWeight: 400,
    lineHeight: 1.55,
    letterSpacing: "0",
  },
  body2: {
    fontSize: "0.9375rem", // 15px
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: "0",
  },
  body3: {
    fontSize: "0.9375rem", // 15px
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: "0",
  },
  body4: {
    fontSize: "0.875rem", // 14px
    fontWeight: 400,
    lineHeight: 1.4,
    letterSpacing: "0em",
  },
  subtitle1: {
    fontSize: "1.125rem", // 18px
    fontWeight: 500,
    lineHeight: 1.45,
    letterSpacing: "0",
  },
  subtitle2: {
    fontSize: "1rem", // 16px
    fontWeight: 500,
    lineHeight: 1.4,
    letterSpacing: "0",
  },
  subtitle3: {
    fontSize: "0.875rem", // 14px
    fontWeight: 500,
    lineHeight: 1.4,
    letterSpacing: "0em",
  },
  button: {
    fontSize: "0.9375rem", // 15px
    textTransform: "none",
    fontWeight: 500,
    letterSpacing: "0",
  },
  caption: {
    fontSize: "0.75rem", // 12px
    fontWeight: 400,
    lineHeight: 1.4,
    letterSpacing: "0.01em",
    color: "text.secondary",
  },
  overline: {
    fontSize: "0.6875rem", // 11px
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
  },
  display: {
    fontFamily: serif,
    fontSize: "2.5rem", // 40px
    fontWeight: 600,
    lineHeight: 1.1,
    letterSpacing: "0em",
  },
};

export default typography;
